module.exports = __webpack_public_path__ + "static/media/icon-plus-white.a9eaeebf.svg";